import type { StoreProfileUser } from '@app/store/types/profile'

export function isSubscriptionRequiredForUser(user: StoreProfileUser): boolean {
  if (!user) return true
  if (user.account_type === 'sitter') return false
  if (user.account_type === 'parent' && user.payment_methods.configured) return false
  return true
}
